// 큐록 · reward/penalty message tables (RAGE_MSGS 는 CUBE_UI_MODE 로 비활성, 정리 대상 deferred)
//
// Pure data — arrays of message strings used by the reward/penalty UI
// (showWin, showRage, showChaekpipty). No state, no DOM.

export const RAGE_MSGS = [
  {face:'',msg:'지금 뭐 하는 거야?!\n그게 음식이야, 독이지.\n의지력도 없으면 아무것도 바뀌지 않아.'},
  {face:'',msg:'변명하지 마.\n그 한 입이 너의 목표를 배신한 거야.\n다음엔 그냥 거울이나 봐.'},
  {face:'',msg:'Soft. 완전히 Soft.\n힘들 때 포기하는 게 습관이 되는 거야.\n지금 이 순간이 너를 정의한다.'},
  {face:'',msg:'그 음식이 널 이긴 거야.\n음식한테 진 거라고.\n규율을 잊었어?'},
  {face:'',msg:'고통 없이는 변화 없어.\n근데 넌 지금 고통 대신 쾌락을 선택했잖아.\n내일 다시 거울 봐.'},
  {face:'',msg:'넌 지금 목표를 팔아치운 거야.\n맛 몇 초에 몇 주를 날렸어.\n그게 진짜 네 모습이야?'},
  {face:'',msg:'챔피언들은 이 순간에 참는다.\n근데 넌 참지 못했어.\n그래서 아직 챔피언이 아닌 거야.'},
  {face:'',msg:'배고픈 게 아니야.\n그냥 약한 거야.\n배고픔과 나약함을 구별 못하면 평생 그대로야.'},
  {face:'',msg:'그 음식 먹을 때 기분 좋았어?\n잠깐이지.\n후회는 길어. 훨씬 더 길어.'},
  {face:'',msg:'자기 통제가 없으면 아무것도 없어.\n지금 네가 보여준 게 바로 그거야.\n부끄러워야 해.'},
  {face:'',msg:'I don\'t accept that.\n넌 더 잘할 수 있어.\n근데 선택을 안 한 거잖아.'},
  {face:'',msg:'그 입을 통제 못하면\n뭘 통제할 수 있어?\n아무것도 없어.'},
  {face:'',msg:'오늘 그 한 입이\n내일의 너를 만든다.\n어떤 너를 만들고 싶어?'},
  {face:'',msg:'weak. pathetic. soft.\n이 세 단어가 지금 너야.\n다음엔 달라져.'},
  {face:'',msg:'전사들은 전쟁터에서 지지 않아.\n근데 넌 식탁에서 졌어.\n진짜 웃기지 않아?'},
  {face:'',msg:'거울 봐.\n지금 그 모습이 만족스러워?\n아니라면 지금 당장 바꿔.'},
  {face:'',msg:'목표를 잊었어?\n아니면 포기한 거야?\n둘 다 변명이야.'},
  {face:'',msg:'그 음식이 행복을 줄 것 같았어?\n거짓말이야.\n진짜 행복은 통제에서 와.'},
  {face:'',msg:'오늘 진 거야.\n근데 내일 이길 수 있어.\n그 선택은 네 거야.'},
  {face:'',msg:'규율이 말이야?\n말이 아니라 행동이야.\n지금 네 행동은 뭘 말하고 있어?'},
  {face:'',msg:'아프지 않으면 성장하지 않아.\n근데 넌 아픔 대신 맛을 골랐어.\n그 대가를 치를 거야.'},
  {face:'',msg:'누가 너한테 쉽다고 했어?\n쉬운 거 원하면 소파에 누워 있어.\n여기 있을 자격 없어.'},
  {face:'',msg:'규율은 협상 안 해.\n예외도 없어.\n지금 네가 만든 예외가 파멸의 시작이야.'},
  {face:'',msg:'한 번 지면 또 져.\n패턴이 돼.\n지금 끊어.'},
  {face:'',msg:'몸이 원한다고 다 줘?\n그게 동물이야.\n인간은 통제할 수 있어.'},
  {face:'',msg:'변화는 편안함 속에서 오지 않아.\n넌 방금 편안함을 골랐어.\n그러니까 변하지 않는 거야.'},
  {face:'',msg:'이 앱 왜 쓰는 거야?\n재미로?\n진짜 바꿀 생각이 있다면 달라져야 해.'},
  {face:'',msg:'그 칼로리 불태우려면\n한 시간은 더 뛰어야 해.\n그걸 알면서 먹은 거야?'},
  {face:'',msg:'오늘의 약함이\n내일의 실패를 만들어.\n끊어내.'},
  {face:'',msg:'성공한 사람들은\n이 순간에 참았어.\n그게 차이야.'},
  {face:'',msg:'맛있었어? 좋아.\n그 맛이 네 목표보다 중요했어?\n솔직하게 대답해봐.'},
  {face:'',msg:'네 몸은 거짓말 안 해.\n먹은 게 다 보여.\n숨길 수 없어.'},
  {face:'',msg:'자기 자신을 속이는 건\n제일 나쁜 거야.\n넌 지금 그러고 있어.'},
  {face:'',msg:'포기하기 딱 좋은 핑계네.\n근데 핑계는 결과를 바꾸지 않아.\n결과만 남아.'},
  {face:'',msg:'세상은 너한테 관심 없어.\n네가 뭘 먹었든.\n근데 네 몸은 다 기억해.'},
  {face:'',msg:'한 번의 실수?\n아니야.\n이게 반복되면 그게 네 인생이야.'},
  {face:'',msg:'약한 자들은 핑계를 댄다.\n강한 자들은 결과를 만든다.\n넌 지금 어느 쪽이야?'},
  {face:'',msg:'맛 하나에 몸 전체를 팔았어.\n그게 지금 네가 한 거야.\n가치 있는 거래야?'},
  {face:'',msg:'다이어트는 주방에서 결정돼.\n헬스장이 아니야.\n방금 주방에서 졌어.'},
  {face:'',msg:'I\'m not here to make you feel good.\n난 네가 진짜 변하길 원해.\n그러려면 솔직해야 해.'},
  {face:'',msg:'지금 이 화면 보고 있어?\n이게 경고야.\n다음번엔 달라져.'},
  {face:'',msg:'목표가 있다면 행동으로 보여줘.\n말로 하지 말고.\n방금 행동이 뭘 보여줬어?'},
  {face:'',msg:'편한 게 좋아?\n편한 건 성장을 죽여.\n그 음식이 너를 죽이고 있어.'},
  {face:'',msg:'오늘 진 거 인정해.\n인정하고 내일 이겨.\n그게 전부야.'},
  {face:'',msg:'네 미래의 모습이\n지금 네 선택을 보고 있어.\n실망시키지 마.'},
  {face:'',msg:'이기는 습관은 작은 거에서 시작해.\n지금 넌 지는 습관을 만들었어.\n당장 끊어.'},
  {face:'',msg:'배가 고픈 게 아니야.\n심심한 거야.\n심심함에 지면 아무것도 못 이겨.'},
  {face:'',msg:'그 음식 없어도 살 수 있어.\n근데 목표 없이는 못 살아.\n뭐가 더 중요해?'},
  {face:'',msg:'Discipline eats motivation for breakfast.\n근데 넌 지금 motivation도 없잖아.\n규율만 남아.'},
  {face:'',msg:'100번 잘 하다가\n한 번 무너지는 게 아니야.\n매번 선택이야.'},
  {face:'',msg:'네 몸이 보내는 신호?\n그게 욕망이야.\n욕망의 노예가 되지 마.'},
  {face:'',msg:'지금 네 몸속에서\n지방이 웃고 있어.\n그거 알아?'},
  {face:'',msg:'먹고 싶은 대로 먹으면\n되고 싶은 대로 될 수 없어.\n단순한 진리야.'},
  {face:'',msg:'오늘 뭐가 더 강했어?\n의지력? 아니면 음식?\n음식이 이겼어.'},
  {face:'',msg:'세상 쉬운 일 중 하나가\n먹는 거야.\n그것도 통제 못하면 뭘 할 수 있어?'},
  {face:'',msg:'챌린지는 쉬울 때 하는 게 아니야.\n힘들 때 버티는 거야.\n지금이 바로 그 순간이었어.'},
  {face:'',msg:'한 입 두 입 참다 보면\n몸이 달라져.\n근데 넌 참지 않았어.'},
  {face:'',msg:'이 앱을 켠 이유가 뭐야?\n변하려고.\n근데 지금 변하고 있어?'},
  {face:'',msg:'쾌락은 쉬워.\n통제는 어려워.\n어려운 걸 골라야 성장해.'},
  {face:'',msg:'네 목표를 종이에 써 놨어?\n거기 써진 사람이\n방금 뭘 먹었어?'},
  {face:'',msg:'규율은 이렇게 말해.\n편안함은 적이다.\n방금 너는 적을 집에 들였어.'},
  {face:'',msg:'살은 거짓말 안 해.\n운동도 거짓말 안 해.\n음식도 거짓말 안 해.'},
  {face:'',msg:'지금 죄책감 느껴?\n좋아.\n그 감정이 다음에 막아줄 거야.'},
  {face:'',msg:'No days off.\n그 말이 음식에도 적용돼.\n매일 싸워.'},
  {face:'',msg:'성공은 이 순간들의 합이야.\n이 순간, 너는 실패를 선택했어.\n다음 순간은 달라져.'},
  {face:'',msg:'몸은 기억해.\n네가 뭘 먹었는지.\n뭘 하지 않았는지.\n전부 다.'},
  {face:'',msg:'100번 참고 1번 먹으면?\n그 1번이 습관이 돼.\n조심해.'},
  {face:'',msg:'진짜 강한 사람은\n배고플 때 더 강해.\n넌 지금 어때?'},
  {face:'',msg:'변화하고 싶다는 말은 쉬워.\n근데 방금 행동은 뭐였어?\n말이랑 행동이 다르잖아.'},
  {face:'',msg:'목표는 공짜가 아니야.\n대가를 치러야 해.\n그 대가가 지금 참는 거야.'},
  {face:'',msg:'네 몸을 사랑한다면\n이렇게 대우하면 안 돼.\n제대로 해.'},
  {face:'',msg:'오늘이 마지막 실수야.\n내일부터 다시 시작?\n아니. 지금 이 순간부터야.'},
  {face:'',msg:'음식 앞에서 무너지는 건\n다른 모든 것 앞에서도 무너진다는 거야.\n알아?'},
  {face:'',msg:'작은 전투에서 지면\n큰 전쟁을 이길 수 없어.\n지금이 작은 전투였어.'},
  {face:'',msg:'네가 먹은 게 아니야.\n목표가 먹힌 거야.\n차이 알아?'},
  {face:'',msg:'참는 게 힘들어?\n당연하지.\n힘든 걸 해야 강해지는 거야.'},
  {face:'',msg:'I suffered. I sacrificed. I overcame.\n근데 넌 지금 뭘 극복했어?\n아무것도.'},
  {face:'',msg:'배달 앱이 이겼어.\n광고가 이겼어.\n너는 졌어.\n그게 현실이야.'},
  {face:'',msg:'자기 통제력이 0이면\n성공 확률도 0이야.\n수학이야.'},
  {face:'',msg:'이 화면 꺼도\n몸은 기억해.\n영원히.'},
  {face:'',msg:'네 future self가\n지금 너를 보고 있어.\n뭐라고 할 것 같아?'},
  {face:'',msg:'소파가 편해.\n음식이 달아.\n그래서 평범한 사람들이 많은 거야.'},
  {face:'',msg:'지금 포기한 사람들이\n나중에 결과를 부러워해.\n그 사람 될 거야?'},
  {face:'',msg:'Accountability.\n지금 네 자신에게 책임져.\n변명 없이.'},
  {face:'',msg:'몇 칼로리인지 알아?\n계산해봐.\n그걸 태우려면 얼마나 뛰어야 하는지도.'},
  {face:'',msg:'약한 순간은 누구에게나 와.\n근데 강한 사람은 그 순간을 이겨.\n넌 지지 않아도 됐어.'},
  {face:'',msg:'이미 먹었어?\n됐어.\n그럼 지금부터 완벽하게 해.\n자책 말고 행동.'},
  {face:'',msg:'맛있는 음식이 목표보다\n중요해진 순간\n게임은 끝난 거야.'},
  {face:'',msg:'1%의 사람들이\n99%가 하지 않는 선택을 해.\n지금 넌 99%를 선택했어.'},
  {face:'',msg:'This is a test.\n넌 방금 실패했어.\n다음 테스트는 통과해.'},
  {face:'',msg:'죽는 날까지\n자기 자신과 싸우는 거야.\n오늘 한 판 진 거야. 내일 이겨.'},
  {face:'',msg:'규율은 슬로건이 아니야.\n라이프스타일이야.\n지금 네 라이프스타일은?'},
  {face:'',msg:'고통은 선생님이야.\n근데 넌 수업을 빠진 거야.\n그 대가를 몸이 치를 거야.'},
  {face:'',msg:'먹고 싶다는 생각이 들었을 때\n이걸 봤어야 했어.\n다음엔 먹기 전에 열어봐.'},
  {face:'',msg:'네 몸은 네 가장 정직한 일기야.\n지금 뭐라고 쓰여 있어?\n솔직하게 읽어봐.'},
];

export const WIN_MSGS = {
  weight:['몸을 직면했어. 그게 용기야.','숫자가 두렵지 않은 자가 변한다.','기록이 변화의 시작이야.'],
  weight_loss:['줄었어. 통제가 시작됐다.','어제보다 가벼워졌어. 계속해.','감량은 의지의 증거야.'],
  weight_goal:['목표에 도달했어. 진짜 시작은 지금부터야.','목표 달성. 하지만 멈추지 마.','숫자가 증명했어. 넌 할 수 있어.'],
  diet_clean:['클린 식단. 몸이 고마워할 거야.','먹는 것이 곧 너야. 잘했어.','통제된 식단이 통제된 삶을 만들어.'],
  routine: [
    '루틴 완료! 이게 바로 규율이다.',
    '하나씩 쌓이는 거야. 멈추지 마.',
    '오늘도 지켰어. 내일도 지켜.',
    '규율이 동기보다 강하다. 증명했어.',
    '이게 습관이 되는 거야. 계속해.',
    '작은 승리. 하지만 진짜 승리.',
    '아무도 안 볼 때도 해냈어. 그게 진짜야.',
    '어제의 너도 인정할 거다.',
    '이 순간이 쌓여서 전설이 된다.',
    'Done. 다음으로.',
    '오늘 지켰어. 내일도 지켜.',
    '작은 거 하나. 근데 엄청 중요한 거.',
    '체크. 다음.',
    '루틴이 인생을 만든다.',
    '오늘 너는 이겼어.',
    '기분이 어때? 이게 자기 통제야.',
    '규율 있는 삶. 이게 시작이야.',
    '오늘 하루 한 발짝 더.',
    '완료. 이게 전부야. 완료.',
    '챔피언들은 이렇게 해. 매일.',
    '아무도 안 봐도 해냈어. 그게 real이야.',
    '미래의 네가 지금 너한테 고마워할 거야.',
    '몸이 기억해. 오늘을.',
    '한 번 더. 그게 전부야.',
    '이 순간을 기억해. 이게 너야.',
    'No excuses. 그냥 했어. 최고.',
    '지금 이 느낌. 기억해. 계속 원하게 돼.',
    '일관성이 재능을 이겨. 증명했어.',
    '하루 하나씩. 인생이 바뀐다.',
    '규율은 자존감이야. 방금 만들었어.',
    '이게 쌓이면 6개월 후 달라진 너야.',
    '오늘도 지켰어. 이게 진짜 성공이야.',
    '작은 것들이 위대한 것을 만든다.',
    '습관이 됐어. 멈추지 마.',
    '이 체크 하나가 인생을 바꿔.',
    '해냈어. 끝.',
    'Discipline = Freedom. 오늘 자유로워졌어.',
    '규율 있는 사람만 아는 느낌이야.',
    '이게 네 normal이 되고 있어. 좋아.',
    '매일매일. 예외 없이. 그게 너야.',
    '강해지고 있어. 눈에 안 보여도.',
    '오늘 이긴 사람 여기 있네.',
    '99%가 안 할 때 넌 했어.',
    '이 순간이 전환점이 될 수도 있어.',
    '체크 하나. 엄청난 의미.',
    '계속해. 지금 잘 하고 있어.',
    '루틴이 너를 보호해. 지켜줘.',
    '오늘 무너지지 않았어. 대단해.',
    '이게 바로 규율이야.',
    '완료. 다음 단계로 가.',
    '성공한 사람들이 다 이렇게 했어.',
    '오늘 버텼어. 내일도 버텨.',
    '이 루틴이 너를 만들고 있어.',
    '나약함이 졌어. 오늘은 네가 이겼어.',
    '완벽하지 않아도 돼. 하면 돼.',
    '자기 통제의 맛. 어때?',
    '기록됐어. 영원히.',
    '이 느낌 기억해. 이게 progress야.',
    '작은 습관이 위대한 삶을 만든다.',
    '오늘도 해냈어. 진심으로 잘했어.',
    '멈추지 마. 절대.',
    '이 체크가 네 future를 만들어.',
    '오늘의 나. 어제보다 강해.',
    '규율 있는 삶. 시작됐어.',
    '이게 습관이 되는 순간이야.',
    '완료. 이게 전부야. 그리고 그게 충분해.',
    '한 번 더 이겼어. 계속 이겨.',
    '규율. 오늘도.',
    '챔피언의 루틴. 지금 하고 있어.',
    '이 순간들이 모여 전설이 된다.',
    '잘했어. 진짜로.',
    '강해지는 중이야. 느껴져?',
    '규율 = 자유. 방금 자유로워졌어.',
    '완료. 이게 네 인생이야.',
    '하루하루가 쌓여. 멈추지 마.',
    '이 루틴이 너를 지켜줄 거야.',
    '해냈어. 그게 전부야. 완벽해.',
    '오늘도 한 발짝. 계속 가.',
    '이기는 사람들의 비밀. 그냥 한다.',
    '이 체크 하나가 모든 것을 바꿔.',
    'Done is better than perfect.',
    '완료. 그 다음 완료. 그게 삶이야.',
    '오늘 너한테 진 것들이 있어. 그것들이 루틴이야.',
    '이게 바로 self-mastery야.',
    '완료. 기억해. 이 느낌.',
    '오늘 네 몸에 한 약속 지켰어.',
    '규율 있는 인생. 살고 있어.',
    '이 순간을 자랑스러워해도 돼.',
    '계속해. 끝이 없어. 그게 삶이야.',
    '평범한 사람들은 이걸 안 해. 넌 했어.',
    '오늘도 승리. 내일도 승리.',
    '완료. 다음. 그게 챔피언이야.',
    '이 느낌. 중독돼. 좋은 방향으로.',
    '해냈어. 진짜 해냈어.',
    '이게 쌓여서 너를 만든다.',
    '규율. 매일. 예외 없이.',
    '오늘 너는 챔피언이야.',
    '이 루틴이 네 갑옷이야. 입었어.',
    '완료. 완벽해. 계속해.',
    '작은 것들. 하지만 전부 다.',
  ],
  task: [
    '할일 정복! 작은 승리가 쌓인다.',
    'Done. 다음으로.',
    '해냈어. 이게 자기 통제야.',
    '체크. 다음. 그게 전부야.',
    '할일 완료. 하루 지배 중.',
    '미뤘어? 안 미뤘어. 그게 차이야.',
    '오늘 할 일 했어. 내일의 내가 고마워할 거야.',
    '완료. 이게 모멘텀이야.',
    '일 처리하는 사람. 그게 너야.',
    'Done. 다음.',
    '체크리스트 정복 중. 계속해.',
    '이 하나가 전체 흐름을 바꿔.',
    '실행력. 그게 너의 무기야.',
    '생각보다 행동. 해냈어.',
    '할 일은 하는 거야. 했어. 완벽해.',
    '이 체크가 하루를 만들어.',
    '오늘도 한 발짝 더 나아갔어.',
    '미루지 않았어. 강한 거야.',
    '완료. 이게 성공이야.',
    '실행한 사람만 아는 느낌이야.',
    '리스트가 줄어들고 있어. 좋아.',
    '하나씩 지워나가. 그게 삶이야.',
    '완료. 다음 목표로.',
    '이 할일이 네 목표의 벽돌이야.',
    '체크. 한 번 더. 그게 전부야.',
    'Done. 이 느낌 기억해.',
    '오늘 계획 실행 중. 강해.',
    '생산적인 하루. 만들고 있어.',
    '할일을 미루지 않는 사람. 그게 너야.',
    '이 순간이 쌓여 성공이 된다.',
    '완료 체크. 가장 기분 좋은 소리.',
    '실행력 최고. 계속해.',
    '오늘 할 일 했어. 충분해.',
    'Done beats perfect. 했어.',
    '이 체크 하나. 큰 의미야.',
    '완료. 다음. 멈추지 마.',
    '실행하는 사람이 결국 이긴다.',
    '체크. 이게 습관이 되고 있어.',
    '오늘의 할일. 완료.',
    '작은 것들이 큰 것을 만든다.',
    '하루를 지배하고 있어.',
    '미뤘다가 했어? 그래도 했어. 대단해.',
    '이 하나로 모멘텀이 생겨.',
    '완료의 연속. 그게 성공이야.',
    '실행. 그게 전부야.',
    '오늘 이긴 사람. 여기 있어.',
    '체크리스트가 줄어들수록 자유로워져.',
    '이 완료가 자존감을 만들어.',
    'Done. 이게 최고의 기분이야.',
    '계획대로 가고 있어. 완벽해.',
  ],
  workout: [
    '운동 완료! 오늘 너는 이겼다.',
    '몸이 기억한다. 오늘을.',
    '고통을 즐겼어. 진짜다.',
    '오늘 운동한 사람. 그게 너야.',
    '땀이 증거야. 진짜 증거.',
    '몸이 달라지고 있어. 느껴져?',
    '운동 완료. 이게 자기 사랑이야.',
    '고통이 지나면 강함이 남아.',
    '오늘 한 시간. 인생이 바뀌는 중.',
    '헬스장에서 이겼어. 오늘.',
    '세트 완료. 다음 주에 더 무거워.',
    '근육이 성장하고 있어. 지금.',
    '운동한 사람만 아는 이 느낌.',
    '땀 흘렸어. 그게 전부야.',
    '오늘 몸에 투자했어. 최고의 투자.',
    '완료. 내일도 와.',
    '몸이 고마워하고 있어. 진짜로.',
    '규율대로. 오늘 해냈어.',
    '운동은 거짓말 안 해. 했으면 달라져.',
    '오늘 한계를 넘었어. 조금씩.',
    '멈추고 싶었어? 근데 안 멈췄어. 그게 챔피언이야.',
    '세트마다 강해지고 있어.',
    '이 운동이 쌓여서 전설이 된다.',
    '오늘 몸과의 약속 지켰어.',
    '운동 완료. 하루 완성.',
    '땀은 지방이 우는 소리야.',
    '오늘 운동. 내일의 나를 만드는 중.',
    'No pain, no gain. 오늘 얻었어.',
    '완료. 샤워하고 또 해낸 하루야.',
    '몸이 달라지는 중. 계속해.',
    '오늘 운동한 사람. 1% 안에 들어.',
    '이 느낌 기억해. 내일 또 와.',
    '힘들었어? 그래서 성장하는 거야.',
    '운동 체크. 하루 지배 완료.',
    '오늘 진짜 일 했어. 몸으로.',
    '한계가 조금 더 멀어졌어. 오늘.',
    '근육은 기억해. 오늘의 노력을.',
    '운동 완료. 그게 전부야. 완벽해.',
    '강해지는 게 보여. 계속해.',
    '오늘 몸에 투자한 사람. 여기 있어.',
    '완료. 내일이 기다리고 있어.',
    '이 운동이 네 갑옷이야.',
    '고통 속에서 챔피언이 만들어진다.',
    '운동은 배신 안 해. 했으면 결과 와.',
    '오늘 해냈어. 진심으로 대단해.',
    '몸이 변하고 있어. 지금. 이 순간.',
    '규율. 운동으로 증명했어.',
    '이게 바로 자기 사랑이야.',
    '완료. 다음 레벨로 가.',
    '오늘 운동. 내일 더 강한 나.',
  ],
  perfect: [
    '완벽한 하루.\n오늘 넌 진짜 기록자다.',
    '이게 바로 진짜 레벨.\n오늘 하루 완전 지배했다!',
    '100점!\n오늘 너는 챔피언이었어.\n내일도 이렇게 해.',
    '완벽해.\n이런 날이 쌓이면 전설이 된다.',
    '오늘 아무것도 너를 막지 못했어.\n그게 기록된다.',
    '고개를 끄덕일 하루였어.\n대단해. 진짜로.',
    '완벽한 하루.\n자랑스러워해도 돼.\n충분히 그럴 자격 있어.',
    '오늘 너는 1%였어.\n내일도 1%로 살아.',
    '식단, 운동, 루틴, 할일.\n전부 다 해냈어.\n이게 삶의 통제야.',
    '오늘의 너.\n어제보다 강하고 내일보다 약해.\n계속 강해져.',
  ],
};

export const RAGE_HEAVY = [
  {face:'',msg:'개가 똥을 끊지 짖어봐!'},
  {face:'',msg:'WTF 너 방금 하루 종일 노력한 거 다 날렸어.'},
  {face:'',msg:'뭐해? 쳐먹었으면 움직여!'},
  {face:'',msg:"Don't you see that?\n너 우습게 보는 새끼들 지금 좋아 죽는다."},
  {face:'',msg:'Fuck you!\n네 인생에서 고작 3-4개월 참는 것도 못해?'},
  {face:'',msg:'Shit!\n옆집 누렁이, 할머니, 할아버지, 네가 이 새끼보다 낫지 하는 그 새끼도 한다.\nStay hard.'},
  {face:'',msg:'어려워? 독립운동하냐?\n아무것도 아닌 것처럼 생각해.\nIt\'s fucking easy.'},
  {face:'',msg:'어플 지워라.\n너한테 한마디 하는 것도 아깝다.\nLittle loser.'},
  {face:'',msg:'아빠도 이제 한계다.\n집 나가서 네 인생 살아라.'},
];

// ═══════════════════════════════════════════════
// 채찍피티 — 룰 기반 유산소 징역 선고
// ═══════════════════════════════════════════════
export const CHAEK_SENTENCES = [
  {
    sentence:'걷기 3시간 유산소 징역형 선고!\n그 칼로리 다 태우고 와.\n도망가면 더 힘들어진다.',
    icon:'', name:'걷기', cat:'cardio', meta:'3시간 유산소', _isChaek:true
  },
  {
    sentence:'러닝 2시간 강제 집행!\n뛰면서 후회해.\n변명은 필요 없어.',
    icon:'', name:'달리기', cat:'cardio', meta:'2시간 유산소', _isChaek:true
  },
];
